import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}

const blogFiltersButtons = document.querySelectorAll('a[href*="/tagged"]');

if (blogFiltersButtons) {
  const currentPath = window.location.pathname;
  blogFiltersButtons.forEach(button => {
    const buttonPath = button.getAttribute('href');
    if (currentPath.includes(buttonPath)) {
      button.parentElement.classList.add('filter-active');
    }
  });
}